/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 16V12M18 16H14M18 16L14.4196 11.7036C14.4035 11.6842 14.3954 11.6744 14.3886 11.6665C13.6371 10.7835 12.2946 10.7226 11.4662 11.5339C11.4588 11.5412 11.4498 11.5502 11.432 11.568V11.568C11.4155 11.5845 11.4072 11.5928 11.4002 11.5997C10.6225 12.3622 9.37753 12.3622 8.59979 11.5997C8.59275 11.5928 8.58452 11.5845 8.56804 11.568L6 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 16V12M18 16H14M18 16L14.4196 11.7036C13.6573 10.7888 12.274 10.726 11.432 11.568V11.568C10.6411 12.3589 9.35889 12.3589 8.56804 11.568L6 9M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM6.53033 8.46967C6.23744 8.17678 5.76256 8.17678 5.46967 8.46967C5.17678 8.76256 5.17678 9.23744 5.46967 9.53033L8.03771 12.0984L8.04033 12.101L8.07471 12.1352C9.1441 13.1837 10.8559 13.1837 11.9253 12.1352L11.9597 12.101L11.9623 12.0984L11.991 12.0698C12.5087 11.5627 13.3478 11.6008 13.8175 12.1526L13.8435 12.1837L16.3987 15.25H14C13.5858 15.25 13.25 15.5858 13.25 16C13.25 16.4142 13.5858 16.75 14 16.75H18C18.4142 16.75 18.75 16.4142 18.75 16V12C18.75 11.5858 18.4142 11.25 18 11.25C17.5858 11.25 17.25 11.5858 17.25 12V13.9285L14.9958 11.2234L14.9932 11.2203L14.993 11.22C14.9794 11.2038 14.969 11.1913 14.9597 11.1804C13.9264 9.96631 12.0805 9.88258 10.9414 10.9981C10.9311 11.0082 10.9196 11.0197 10.9046 11.0348L10.9016 11.0377L10.8751 11.0641C10.389 11.5407 9.61096 11.5407 9.12487 11.0641L9.09837 11.0377L6.53033 8.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M18 16V12M18 16H14M18 16L14.4196 11.7036C13.6573 10.7888 12.274 10.726 11.432 11.568V11.568C10.6411 12.3589 9.35889 12.3589 8.56804 11.568L6 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 16V12M18 16H14M18 16L14.4196 11.7036C13.6573 10.7888 12.274 10.726 11.432 11.568V11.568C10.6411 12.3589 9.35889 12.3589 8.56804 11.568L6 9M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.46967 8.46967C5.76256 8.17678 6.23744 8.17678 6.53033 8.46967L9.09837 11.0377L9.12487 11.0641C9.61096 11.5407 10.389 11.5407 10.8751 11.0641L10.9016 11.0377L10.9046 11.0348C10.9196 11.0197 10.9311 11.0082 10.9414 10.9981C12.0805 9.88258 13.9264 9.96631 14.9597 11.1804C14.9691 11.1914 14.9796 11.204 14.9932 11.2203L14.9958 11.2234L17.25 13.9285V12C17.25 11.5858 17.5858 11.25 18 11.25C18.4142 11.25 18.75 11.5858 18.75 12V16C18.75 16.4142 18.4142 16.75 18 16.75H14C13.5858 16.75 13.25 16.4142 13.25 16C13.25 15.5858 13.5858 15.25 14 15.25H16.3987L13.8435 12.1837L13.8175 12.1526C13.3478 11.6008 12.5087 11.5627 11.991 12.0698L11.9623 12.0984L11.9597 12.101C11.9457 12.1149 11.935 12.1256 11.9253 12.1352C10.8559 13.1837 9.1441 13.1837 8.07471 12.1352C8.06498 12.1256 8.05425 12.1149 8.04033 12.101L8.03771 12.0984L5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
